import useRocketChat from './useRocketChat';
import { RC_DOMAIN } from '../../Helpers/EnvVars';

import { Props } from './RocketChat.model';

const RocketChat = ({ roomId, updateChatStatus }: Props) => {
	const { iFrameRef, onLoadIframe } = useRocketChat({
  roomId,
  updateChatStatus
});

	return (
		<iframe
			frameBorder="0"
			id="rocketChat"
			ref={iFrameRef}
			src={`${RC_DOMAIN}/direct/${roomId}`}
			title="myframe"
			onLoad={onLoadIframe} />
	);
}

export default RocketChat;